module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "w-full bg-gray-100 text-sm text-gray-500 p-4 mb-8 rounded"
  }, [_vm._v("\n    This banner image will appear accross the top of the course.\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-5"
  }, _vm._l((_vm.gallery), function(banner, index) {
    return _c('div', {
      key: index,
      staticClass: "sample",
      on: {
        "mouseover": function($event) {
          return _vm.bannerHovered(index)
        },
        "mouseout": function($event) {
          _vm.bannerIndex = null
        }
      }
    }, [_c('div', {
      staticClass: "sample h-20 cursor-pointer relative",
      style: ({
        backgroundImage: 'url(' + _vm.encodeImageURI(banner.pathLong) + ') ',
        'background-size': 'cover',
        'background-position': 'center',
      }),
      on: {
        "mouseover": function($event) {
          return _vm.changeTemporaryBannerUrl(banner)
        },
        "mouseout": _vm.removeTemporaryBanner,
        "click": function($event) {
          _vm.creatingCourse ? _vm.selectBanner(banner) : _vm.changeBannerUrl(banner)
        }
      }
    }, [(
      _vm.bannerSelected &&
      _vm.bannerSelected.pathLong &&
      _vm.bannerSelected.pathLong === banner.pathLong
    ) ? _c('i', {
      staticClass: "fas fa-check-circle absolute right-1 top-1 text-primary",
      staticStyle: {
        "font-size": "16px"
      }
    }) : _vm._e(), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.bannerIndex),
        expression: "index === bannerIndex"
      }],
      staticClass: "fas fa-check-circle absolute right-1 top-1 text-primary opacity-50",
      staticStyle: {
        "font-size": "16px"
      }
    })])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-dc34e87a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/courses/pages/settings/banners.vue
// module id = 2247
// module chunks = 61